<script>
    import {getContext} from 'svelte';
    
    export let _players;
    export let defaultPos;

    let positionInfo = getContext('positionInfo');
    let rank_alias = getContext('rank_alias');
</script>
 {#each _players[defaultPos] as pos }
    {#if (pos) }
 <li class="item" data-tier="{rank_alias[pos.rank]}">
     <button type="button" class="team">
         <span class="img">
             <img
                 src="//upload3.inven.co.kr/upload/{pos.image.small}"
                 alt="{positionInfo.position_kor[pos]} 포지션" width="68" height="69">
         </span>
         <span class="name">{pos.name}</span>
     </button>
 </li>
    {:else}
    <li class="item">
        <button type="button" class="team" disabled>
            <span class="position-txt">{positionInfo.position_simple[defaultPos]}</span>
        </button>
    </li>
    {/if}
 {:else}
 <li class="item">
    <button type="button" class="team" disabled>
        <span class="position-txt">{positionInfo.position_simple[defaultPos]}</span>
    </button>
 </li>
 {/each}